import React from 'react';
import { useTranslations } from '../hooks/useTranslations';

export const CopyrightWatermark: React.FC = () => {
  const t = useTranslations();

  return (
    <div className="absolute bottom-2 sm:bottom-4 left-1/2 transform -translate-x-1/2 text-xs text-gray-400 opacity-60 z-10">
      <div className="flex flex-col items-center gap-1">
        <div className="pointer-events-none text-[10px] sm:text-xs">{t.ui.copyright}</div>
        <a 
          href={`mailto:${t.ui.contactEmail}`}
          className="text-gray-500 hover:text-gray-700 underline pointer-events-auto transition-colors text-[10px] sm:text-xs"
          onClick={(e) => e.stopPropagation()}
        >
          {t.ui.contactUs}
        </a>
      </div>
    </div>
  );
};

